import React from 'react';
import StudentsNavbar from '../../Components/Navbars/StudentsNavbar';
import { BaseCompanyPage } from './BaseCompanyPage';

export const CompanyPageForStudent = () => {

    return (
        <>
            <StudentsNavbar />
            <BaseCompanyPage />
        </>
    );
};